export const ADVANCED_LABS_RAF_SOURCE = 'advanced_labs_early_access';

export const ADVANCED_LABS_VALID_REGIONS = ['US'];
